import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Observable, of } from "rxjs";
import { debounceTime, map, startWith } from "rxjs/operators";

import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatChipGrid, MatChipInputEvent } from "@angular/material/chips";


export interface KeyValuePair  {
  key: string;
  value: string;
}

@Component({
  selector: 'chips-autocomplete-input',
  templateUrl: './chips-autocomplete-input.component.html',
  styleUrls: ['./chips-autocomplete-input.component.scss'],
  providers: [
    {       provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChipsAutocompleteInputComponent),
      multi: true
    }]
})
export class ChipsAutocompleteInputComponent implements OnInit,ControlValueAccessor  {


  @Input() set values(value:KeyValuePair[]){
    this.contactData = value;
    if(this.formGroup?.get("chipsInput")?.value != null){
      this.filteredValues$ = of(this.chipFilter(this.formGroup.get("chipsInput").value));
    }
    this.isLoading = false;
  };
  @Input() set startSelectedValues(value:KeyValuePair[]){
    if(value != null){
      for (let i = 0; i < value.length; i++)
      {
        this.loadStartChip(value[i]);
      }
    }
  };
  @Input() required :boolean;
  @Input() allowedNew:boolean;
  @Input() onlySingle:boolean;
  @Output() onChanged = new EventEmitter<{ searchQuery: string }>();


  public selectedValues:KeyValuePair[] = [];
  public contactData:KeyValuePair[] = [];
  public removable = true;
  public addOnBlur = true;
  public isLoading = false;

  public filteredValues$: Observable<KeyValuePair[]>;

  formGroup:FormGroup;

  @ViewChild("chipList") chipList: MatChipGrid;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(private _formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      chipsInput: [null],
      chips:[null]
    });
    this.initValueChanged();
  }

  onChange: any = () => {}
  onTouch: any = () => {}

  val:string[];
  set value(val){
    this.val = val
    this.onChange(val)
    this.onTouch(val)
  }

  writeValue(value: any){
    this.value = value
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }

  private loadStartChip(data:KeyValuePair): void {
    const value = data;

    if (value  && !this.selectedValues.includes(value)) {

      this.selectedValues.push(value);
      this.formGroup.get("chips").setValue(this.selectedValues);
      this.formGroup.get("chipsInput").setValue("");
      this.writeValue(this.selectedValues);

    }
  }

  public selectChip(event: MatAutocompleteSelectedEvent): void {
    if (!event.option) {
      return;
    }
    const value = event.option.value;
    if (value  && !this.selectedValues.includes(value)) {
      if(this.onlySingle){
        this.selectedValues=[];
      }
      this.selectedValues.push(value);
      this.formGroup.get("chips").setValue(this.selectedValues);
      this.formGroup.get("chipsInput").setValue("");
      this.writeValue(this.selectedValues);
    }
  }

  public addChip(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if (value.trim()) {
      const matches = this.selectedValues.filter(
        item => item.value.toLowerCase() === value
      );
      const formValue = this.formGroup.get("chips").value;
      const matchesNotYetSelected =
        formValue === null
          ? matches
          : matches.filter(x => !formValue.find(y => y === x));
      if (matchesNotYetSelected.length === 1) {
        if(this.onlySingle){
          this.selectedValues=[];
        }
        this.selectedValues.push(matchesNotYetSelected[0]);
        this.formGroup.get("chips").setValue(this.selectedValues);
        this.formGroup.get("chipsInput").setValue("");
        this.writeValue(this.selectedValues);
      }else{
        if(this.allowedNew){
          if(this.onlySingle){
            this.selectedValues=[];
          }
          this.selectedValues.push({key:'0', value:value});
          this.formGroup.get("chips").setValue(this.selectedValues);
          this.formGroup.get("chipsInput").setValue("");
          this.writeValue(this.selectedValues);
        }

      }
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  public remove(chip: KeyValuePair) {
    const index = this.selectedValues.indexOf(chip);
    if (index >= 0) {
      this.selectedValues.splice(index, 1);
      this.formGroup.get("chips").setValue(this.selectedValues);
      this.formGroup.get("chipsInput").setValue("");
      this.writeValue(this.selectedValues);
    }
  }

  private chipFilter(value: any): KeyValuePair[] {
    const filterValue = value === null || value instanceof Object ? "" : value.toLowerCase();
    const matches = this.contactData.filter(item =>
      item.value.toLowerCase().includes(filterValue)
    );
    const formValue = this.formGroup.get("chips").value;
    return formValue === null
      ? matches
      : matches.filter(x => !formValue.find(y => y.value === x.value));
  }

  private initValueChanged() {
    if (this.onChanged.observers.length > 0)
    {
      this.formGroup.get("chipsInput").valueChanges.pipe(debounceTime(300)).subscribe(val => {
        this.isLoading = true;
        this.onChanged.emit({searchQuery: val});
      });


    } else {
      this.filteredValues$ = this.formGroup.get("chipsInput").valueChanges.pipe(
        startWith(""),
        map(value => this.chipFilter(value))
      );
    }
  }
}
